module.exports = __webpack_public_path__ + "img/jcsjcjwg1.cde5db45.jpg";